export default __webpack_public_path__ + "static/media/Blade of the Turanian Army.c951f86e.jpg";